import React from 'react'
import Icons from '../assets/icons'
import { twMerge } from 'tailwind-merge'

interface CheckboxProps {
    id: string,
    label: string,
    checked: boolean,
    onCheckedChange?: (checked: boolean) => void, 
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
    labelClassProps?: string
    error?: string,
    containerClassProps?: string,
    disabled?: boolean,
    [key: string]: any 
}

const Checkbox: React.FC<CheckboxProps> = ({ 
    id, 
    label, 
    labelClassProps, 
    checked, 
    onCheckedChange,
    onChange,
    error = '', 
    containerClassProps = '', 
    disabled = false,
    ...props 
}) => {
    
  const CheckboxStyle = 'appearance-none w-6 h-6 rounded-sm border-2 checked:bg-primario-500 fill-primario-700'
  const CheckboxDisabledStyle = (): string => { return disabled ? 'border-neutro-200 bg-neutro-100 cursor-not-allowed' : 'border-primario-700' }
  const CheckboxFinalStyle = twMerge(CheckboxStyle, CheckboxDisabledStyle())
  const CheckStyle = 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none'

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (onCheckedChange) {
      onCheckedChange(event.target.checked);
    }
    
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={containerClassProps}>
      <div className="flex items-center gap-2">
        <span className='relative h-6'>
            <input 
              id={id} 
              checked={checked} 
              name={id} 
              className={CheckboxFinalStyle} 
              type="checkbox" 
              disabled={disabled}
              onChange={handleChange} 
              {...props}
            />
            { checked && <Icons.Check svgStyle={CheckStyle} pathStyle='fill-white'/>}
        </span>
        <label className={twMerge(labelClassProps, disabled ? 'cursor-not-allowed opacity-70' : '')} htmlFor={id}>{label}</label>
      </div>
      { error && <p className='text-erro-500 mt-1'>{error}</p> }
    </div>
  )
}

export default Checkbox;